<template>

    <div>

        <loading-indicator :loading="isLoading"></loading-indicator>

        <template v-if="!isLoading">

            <v-client-table ref="siteNewsletters" name="siteNewsletters" :data="siteNewsletters" :columns="table.tblColumns" :options="table.tblOptions" class="tbl-newsletter noFirstColumn">

                <!-- before table -->
                <template slot="beforeTable">

                    <div class="button is-primary is-pulled-right" @click="newsletterNew()">
                        <span class="icon is-small"><i class="icon-ak-hinzufuegen"></i></span>Neuer Newsletter
                    </div>

                    <div class="is-pulled-left">
                        <div class="columns is-marginless filters">

                            <div class="column">
                                <form-input label="COMPLAT-NEWSLETTER-FILTER-STATUS" maxWidth="250px" :showLabel="false" inputType="select" selectFieldName="displayName" :showLabelInOptions="false" :selectOptions="newsletterStatus" v-model="filterStatus" :is-horizontal="true"></form-input>
                            </div>

                        </div>
                    </div>

                </template>


                <template slot="name" slot-scope="props">

                    <template v-if="props.row.siteNewsletter != null && props.row.siteNewsletter.title != null">
                        {{ props.row.siteNewsletter.title }}
                    </template>
                    <template v-else>
                        {{ props.row.name }}
                    </template>

                </template>

                <template slot="type" slot-scope="props">
                    {{ props.row.name }}
                </template>

                <template slot="scheduleDate" slot-scope="props">

                    <template v-if="props.row.scheduleDate == null">
                        -
                    </template>
                    <template v-else>
                        {{ formatDate2(props.row.scheduleDate, false) }}
                    </template>

                </template>

                <template slot="updatedAt" slot-scope="props">

                    <template v-if="typeof props.row.siteNewsletter != 'undefined'">
                        {{ formatDate(props.row.updatedAt) }}
                    </template>

                </template>

                <template slot="sendDate" slot-scope="props">
                    <template v-if="props.row.sendDate != null">
                        {{ formatDate2(props.row.sendDate, false) }}
                    </template>
                </template>

                <template slot="status" slot-scope="props">

                    <template v-if="props.row.siteNewsletter != null">

                        <template v-if="props.row.status == null || newsletterStatus.DRAFT.id == props.row.status">
                            {{ newsletterStatus.DRAFT.displayName }}
                            <!-- <lang labelKey="COMPLAT-NEWSLETTER-STATUS-DRAFT"></lang> -->
                            <!-- <lang :labelKey="'COMPLAT-NEWSLETTER-STATUS-'+props.row.status.name"></lang> -->
                        </template>
                        <template v-else>
                            <lang labelKey="COMPLAT-NEWSLETTER-STATUS-SENT"></lang>
                        </template>

                    </template>

                </template>

                <template slot="subscribers" slot-scope="props">
                    {{ props.row.recipientCount }}
                </template>

                <template slot="opens" slot-scope="props">
    
                    <template v-if="openRate != null">
                        {{ round(props.row.openRate * 100, 1) }}%
                    </template>
                </template>

                <template slot="clicks" slot-scope="props">
                    <template v-if="clickRate != null">
                        {{ round(props.row.clickRate * 100, 1) }}%
                    </template>
                </template>

                <template slot="edit" slot-scope="props">

                    <template v-if="typeof props.row.siteNewsletter != 'undefined'">

                        <template v-if="props.row.siteNewsletter != null && (props.row.status == null || props.row.status == '156')">
                            <pop-confirm class="icon is-small" content="Soll dieser Newsletter wirklich gelöscht werden?" :on-ok="function() { newsletterDelete(props.row) }">
                                <i class="icon-ak-entfernen"></i>
                            </pop-confirm>
                        </template>

                        <template v-else>
                            <span class="icon is-small is-disabled" disabled><i class="icon-ak-entfernen"></i></span>
                        </template>

                    </template>

                </template>

            </v-client-table>

        </template>


    </div>

</template>


<script>
import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

export default {

    props: {

        newsletters: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: true
        }

    },

    data() {

        var self = this;

        return {
            isLoading: true,
            filterStatus: null,
            siteNewsletters: null,
            table: {

				tblColumns: ['name', 'scheduleDate', 'updatedAt', 'sendDate', 'status', 'subscribers', 'opens', 'clicks', 'edit'],

                tblOptions: {
					trackBy: 'id',
                    uniqueKey: 'id',
					saveState: false,
					perPage: 25,
					orderBy: {
                        column: 'updatedAt',
						ascending: false,
					},

                    // custom table headings - make them clickable for language Setting
					headings: {
						name(h) {
							return <lang labelKey="COMPLAT-NEWSLETTERS-TBL_HEADER-TITLE"></lang>
						},
						updatedAt(h) {
							return <lang labelKey="COMPLAT-NEWSLETTERS-TBL_HEADER-UPDATED"></lang>
						},
                        sendDate(h) {
							return <lang labelKey="COMPLAT-NEWSLETTERS-TBL_HEADER-SEND_DATE"></lang>
						},
						scheduleDate(h) {
							return <lang labelKey="COMPLAT-NEWSLETTERS-TBL_HEADER-SCHEDULE_DATE"></lang>
						},
						status(h) {
							return <lang labelKey="COMPLAT-NEWSLETTERS-TBL_HEADER-STATUS"></lang>
						},
						subscribers(h) {
							return <lang labelKey="COMPLAT-NEWSLETTERS-TBL_HEADER-SUBSCRIBERS"></lang>
						},
						opens(h) {
							return <lang labelKey="COMPLAT-NEWSLETTERS-TBL_HEADER-OPENS"></lang>
						},
						clicks(h) {
							return <lang labelKey="COMPLAT-NEWSLETTERS-TBL_HEADER-CLICKS"></lang>
						},
						edit(h) {
                            return <lang labelKey="EQUIPMENTS_TBL_HEADER-DELETE"></lang>
							// return 'edit';
                        },
					},

					sortable: ['type', 'scheduleDate', 'name', 'updatedAt', 'sendDate', 'status', 'subscribers', 'opens', 'clicks'],
					sortIcon: {
                        base:'fa',
                        up:'fa-sort-up',
                        down:'fa-sort-down',
                        is:'fa-sort'
                    },

					filterByColumn: false,
					filterable: false,

					texts: {
						filter: 'Filter Ergebnisse:',
						filterPlaceholder: 'Suche',
						limit: 'Einträge pro Seite',
						noResults: 'keine passenden Einträge gefunden',
						count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
					},

					pagination: {
						chunk: 5
					},

					skin: 'table is-striped is-hoverable is-fullwidth',

					// custom filter functions
					customFilters: [
						{
						name: 'filterStatus',
                            callback: function(row, status) {
                                if(status == null || status == "") {
                                    return true;
                                }
                                if(status.name == 'DRAFT') {
                                    return row.status == null || row.status == status.id
                                } else {
                                    return row.status == status.id;
                                }

        						return false;
                            }
                        }
					],

                    // initial filtering
                    initFilters: {
    					filterStatus: { name: 'DRAFT', id: 156 }
                    },

                    columnsClasses: { 'edit': 'edit' },
                    rowClassCallback: function (row) {

                        return typeof row.siteNewsletter == 'undefined' ? 'template' : '';

                    },


				}
			}

        }
    },

    watch: {

        loading(val) {

            this.isLoading = val;
            this.siteNewsletters = this.newsletters;
        },

        filterStatus(newVal, oldVal) {

	        setTimeout(function() {
	            Event.$emit('vue-tables.siteNewsletters.filter::filterStatus', newVal);
	        }, 10);

		}

    },

    computed: {

		newsletterStatus() {
			// return this.$store.getters.getTermsByTaxonomy('NEWSLETTER_STATUS');
            let status = this.$store.getters.getTermsByTaxonomy('NEWSLETTER_STATUS');

            for(let key in status) {
                status[key].displayName = this.$t('NEWSLETTER-STATUS-'+status[key].name);
            }

            return status;
		},


        siteId() {

            return this.activeUser.site.id;

        },

	},

    created() {

        this.filterStatus = this.newsletterStatus.DRAFT;

    },

    mounted() {

        Event.$on('vue-tables.siteNewsletters.row-click', function (data) {
            //|| ['edit'].indexOf(data.event.target.parentElement.className) > -1
            if(['edit'].indexOf(data.event.target.className) > -1 ) {
                return false;
            }

            this.newsletterEdit(data.row);

		}.bind(this));

    },

    methods: {

        newsletterNew() {

            this.$emit('select', 'new');

        },

        newsletterEdit(newsletter) {

            this.$emit('select', newsletter);

        },

        newsletterDelete(row) {

            if(row.siteNewsletter!=null && row.siteNewsletter.id) {

                this.axios.delete(this.$config.api + 'siteNewsletter/'+row.siteNewsletter.id).then(res => {
                    this.fetchData();
                    this.$notify.open({content: 'Der Newsletter wurde erfolgreich entfernt!', type: 'success'});
                })

            } else {

                alert("nope ... ");

            }


        },

        fetchData() {

            var self = this;

            this.axios.get(this.$config.api + 'newsletter?site='+this.siteId)
                .then(res=> {

                    // this.siteNewsletters = res.data.newsletter;

                    this.siteNewsletters = [];

                    for(var prop in res.data.newsletter) {
                        self.siteNewsletters.push(res.data.newsletter[prop]);
                    }

                })

        },


    }

}

</script>


<style lang="scss">

    @import '~../../assets/css/variables.scss';

    .tbl-newsletter {


        .VueTables__table tr.template td {
            /*background-color: lighten($themeColor1, 38);*/
            font-weight: bold;
        }


        .VueTables__table tr td {
            padding: 10px 5px !important;
        }
        .VueTables__table tr th:last-child {
            width: 80px;
            max-width: 80px;
            text-align: center;
        }

        .VueTables__table tr td:last-child {
            max-width: 80px;
            text-align: center;

            .icon {
                margin: 3px 0 0 0;
                &.is-disabled {
                    color: #ccc;
                }
            }

        }

    }

</style>
